/**
 * LD Product Payment Buttons - Payment button display and priority management
 */

class LDProductPaymentButtons {
  constructor() {
    this.init();
  }

  /**
   * Force show all payment methods
   */
  forceShowAllPaymentMethods() {
    console.log('LD Product Payment Buttons: Setting up payment button display...');
    
    const shopifyPaymentButton = document.querySelector('.shopify-payment-button');
    if (!shopifyPaymentButton) {
      console.log('LD Product Payment Buttons: No Shopify payment button found');
      return;
    }
    
    // Find the accelerated checkout container
    const acceleratedCheckout = shopifyPaymentButton.querySelector('shopify-accelerated-checkout');
    if (acceleratedCheckout) {
      console.log('LD Product Payment Buttons: Found accelerated checkout, setting up display...');
      
      // Set flex layout for the container
      acceleratedCheckout.style.display = 'flex';
      acceleratedCheckout.style.flexDirection = 'column';
      acceleratedCheckout.style.gap = 'var(--ld-spacing-20)';
      
      // PRIORITY: Try to show Apple Pay first if available
      const applePayButton = shopifyPaymentButton.querySelector('.shopify-payment-button__button--apple-pay');
      if (applePayButton) {
        console.log('LD Product Payment Buttons: Found Apple Pay button, prioritizing it...');
        applePayButton.style.order = '-3';
        applePayButton.style.display = 'block';
        applePayButton.style.visibility = 'visible';
        applePayButton.style.opacity = '1';
      }
      
      // Also check for Google Pay (second priority)
      const googlePayButton = shopifyPaymentButton.querySelector('.shopify-payment-button__button--google-pay');
      if (googlePayButton) {
        console.log('LD Product Payment Buttons: Found Google Pay button, second priority...');
        googlePayButton.style.order = '-2';
        googlePayButton.style.display = 'block';
        googlePayButton.style.visibility = 'visible';
        googlePayButton.style.opacity = '1';
      }
      
      // Check for PayPal (third priority)
      const paypalButton = shopifyPaymentButton.querySelector('.shopify-payment-button__button--paypal');
      if (paypalButton) {
        console.log('LD Product Payment Buttons: Found PayPal button...');
        paypalButton.style.order = '-1';
        paypalButton.style.display = 'block';
        paypalButton.style.visibility = 'visible';
        paypalButton.style.opacity = '1';
      }
      
      // Check for Shop Pay (fourth priority)
      const shopPayButton = shopifyPaymentButton.querySelector('.shopify-payment-button__button--shop-pay');
      if (shopPayButton) {
        console.log('LD Product Payment Buttons: Found Shop Pay button...');
        shopPayButton.style.order = '0';
        shopPayButton.style.display = 'block';
        shopPayButton.style.visibility = 'visible';
        shopPayButton.style.opacity = '1';
      }
      
      // Check for other payment buttons and make them visible
      const otherPaymentButtons = shopifyPaymentButton.querySelectorAll('.shopify-payment-button__button:not(.shopify-payment-button__button--apple-pay):not(.shopify-payment-button__button--google-pay):not(.shopify-payment-button__button--paypal):not(.shopify-payment-button__button--shop-pay)');
      otherPaymentButtons.forEach((button, index) => {
        console.log('LD Product Payment Buttons: Found other payment button:', button.className);
        button.style.order = index + 1;
        button.style.display = 'block';
        button.style.visibility = 'visible';
        button.style.opacity = '1';
      });
      
      console.log('LD Product Payment Buttons: Payment button display setup complete');
    } else {
      console.log('LD Product Payment Buttons: No accelerated checkout container found');
    }
  }

  init() {
    this.forceShowAllPaymentMethods();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.ldProductPaymentButtons = new LDProductPaymentButtons();
});

// Export for ES modules
window.LDProductPaymentButtons = LDProductPaymentButtons;
